/**
 * A two-tone chime synthesised on demand. Shipping no audio asset keeps the
 * bundle honest, and the operator can turn it off entirely.
 */
let context: AudioContext | null = null;

export function playAlertChime(severity: 'INFO' | 'WARNING' | 'CRITICAL' = 'WARNING'): void {
  try {
    context ??= new AudioContext();
    if (context.state === 'suspended') void context.resume();

    const now = context.currentTime;
    const gain = context.createGain();
    gain.connect(context.destination);
    gain.gain.setValueAtTime(0.0001, now);

    const tones = severity === 'CRITICAL' ? [880, 1174, 880] : [660, 880];
    const step = 0.11;

    tones.forEach((frequency, index) => {
      const osc = context!.createOscillator();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(frequency, now + index * step);
      osc.connect(gain);
      osc.start(now + index * step);
      osc.stop(now + index * step + step);
    });

    const total = tones.length * step;
    gain.gain.exponentialRampToValueAtTime(0.12, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + total);
  } catch {
    // Autoplay policy or no audio device — silence is an acceptable outcome.
  }
}
